/* Cart drawer layout — which blocks stay pinned and which scroll with the products.
 *
 * The drawer is one flex column with two children:
 *   .ntf-drawer-items          the scrolling list
 *   .footer-cart-drawer-mobile everything else, pinned to the bottom
 *
 * Today the whole footer is pinned, so the products get roughly a third of the drawer and the rest
 * is a dense block that never moves. Each layout below simply moves some of the footer's blocks into
 * the scrolling area; nothing is rebuilt and no vendor markup is edited, so switching is a one-value
 * change and the next Tapita update has nothing extra to merge.
 *
 * Layout 6 shipped. The ?ntf-cart= switcher this was chosen with is gone.
 *
 *   6  gift box + note/delivery + checkout + payment pinned   (totals scroll)
 *   4  note/delivery + checkout pinned
 *   2  checkout + payment pinned
 *   1  nothing pinned, one continuous column
 */
(function () {
  var LAYOUT = "6";

  /* Each block is found by its own marker, then grown upward to the largest wrapper that still
     contains nothing else we care about. Classifying the footer's direct children does not work:
     it has exactly two, and the first bundles the gift box, the note/delivery row AND the totals
     into one element. Growing from the marker finds the smallest separable unit instead. */
  var MARK = {
    gift:     ".gbp-cta, .cart-drawer-gift-box-personalizer",
    deliv:    "[data-ntf-deliv]",
    trust:    ".ntf-trust, .ntf-pay",
    checkout: "a[href*='/checkout'], button[name='checkout']"
  };
  var KINDS = ["gift", "deliv", "trust", "checkout", "totals"];

  /* The totals block — the one thing layout 6 lifts out of the pinned footer.
   *
   * It used to be found by its LABEL: the first element whose text starts with "subtotal". That
   * works in exactly one language. On /nl the label is "Tussentotaal", on /de "Zwischensumme", on
   * /fr "Sous-total" — no match, totalsEl returned null, the money was never moved, and every
   * non-English storefront rendered the footer in source order instead: gift box, note/delivery,
   * totals, Klarna, checkout, payment. That is a different design, shipped to every customer who
   * was not browsing in English, and it looked like an old build because it was the pre-layout-6
   * arrangement.
   *
   * The block now carries data-ntf-totals from cart-drawer.liquid. An attribute survives
   * translation.
   *
   * The "subtotal" label test that used to stand behind the marker is gone too (25 Sept). It could
   * only ever match in English, so a drawer rendered without the marker would have got layout 6 in
   * English and the source-order footer in every other language — one design per language, the
   * exact failure described above. Without the marker, every language now gets the same footer. */
  function totalsEl(root) {
    return root.querySelector("[data-ntf-totals]");
  }

  function unitFor(root, kind) {
    var el = (kind === "totals") ? totalsEl(root) : root.querySelector(MARK[kind]);
    if (!el) return null;
    var others = KINDS.filter(function (k) { return k !== kind; });
    var node = el;
    while (node.parentElement && node.parentElement !== root) {
      var up = node.parentElement;
      var clash = others.some(function (k) {
        return k === "totals" ? !!totalsEl(up) : !!up.querySelector(MARK[k]);
      });
      if (clash) break;
      node = up;
    }
    return node;
  }

  var PINNED = {
    "6": ["gift", "deliv", "checkout", "trust"],   // money scrolls
    "4": ["deliv", "checkout"],
    "2": ["checkout", "trust"],
    "1": []
  };

  function apply() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return;
    var items = drawer.querySelector(".ntf-drawer-items");
    var footer = drawer.querySelector(".footer-cart-drawer-mobile");
    if (!items || !footer) return;

    var keep = PINNED[LAYOUT] || PINNED[DEFAULT_LAYOUT];
    drawer.setAttribute("data-ntf-cart", LAYOUT);

    var moved = items.querySelector(".ntf-moved");
    if (!moved) {
      moved = document.createElement("div");
      moved.className = "ntf-moved";
      items.appendChild(moved);
    }

    /* Anything this layout wants pinned goes back to the footer first, before the checkout block so
       the reading order stays gift box, note, money, pay. */
    [].slice.call(moved.children).forEach(function (el) {
      var k = el.getAttribute("data-ntf-kind");
      if (keep.indexOf(k) < 0) return;
      var co = unitFor(footer, "checkout");
      footer.insertBefore(el, co || null);
    });

    KINDS.forEach(function (kind) {
      if (keep.indexOf(kind) >= 0) return;
      var unit = unitFor(footer, kind);
      if (!unit || unit === footer) return;
      unit.setAttribute("data-ntf-kind", kind);
      moved.appendChild(unit);
    });
  }
  if (window.NTF_ON_MUTATE) window.NTF_ON_MUTATE(apply);
  else setInterval(apply, 700);
  document.addEventListener("eurus:cart:items-changed", function () { setTimeout(apply, 250); });
  apply();
})();
